import { useMutation } from '@tanstack/react-query';

import type { UpdateRiskBandSetPayload } from 'api/RiskBandsApi';
import { RiskBandsApi } from 'api/RiskBandsApi';
import { useFiRiskAssessmentCache } from 'tanstack-hooks/fi-risk-assessments/risk-assessments-cache';
import { RISK_BANDS_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useUpdateRiskBandSet() {
  const riskBandsApi = new RiskBandsApi();
  const { userBankId } = useUser();
  const { invalidateRiskBandSets } = useFiRiskAssessmentCache();

  const { mutateAsync: updateRiskBandSet, isPending: isUpdatingRiskBandSet } = useMutation({
    mutationKey: [RISK_BANDS_KEY, 'update'],
    mutationFn: ({ id, ...data }: UpdateRiskBandSetPayload & { id: string }) =>
      riskBandsApi.updateRiskBandSet(userBankId, id, data),
    onSuccess: () => {
      invalidateRiskBandSets();
    },
    meta: {
      snackbarSuccessMessage: 'Risk bands saved.',
      snackbarErrorMessage: 'There was an issue saving the risk band set. Please contact support.'
    }
  });

  return { updateRiskBandSet, isUpdatingRiskBandSet };
}
